const TIMEOUT = 3000;

export const returnPromise = async <T>(result: T, timeout?: number): Promise<T> => {
  return new Promise(resolve => {
    setTimeout(() => {
      resolve(result);
    }, timeout ?? TIMEOUT);
  });
};
